import MEETING from 'constant/meeting';
import moment from 'moment';
import { MeetingMember } from 'type/meeting';
import dayjs from 'dayjs';

export function formatRemind (val: string):string {
  const map = MEETING.REMIND_OPTIONS.reduce((m, r) => {
    m[r.value] = r.label;
    return m;
  }, {} as {[k: string]: string});

  return map[val];
};

export function formatMeetingType (val?: number):string {
  const map = MEETING.TYPE_OPTIONS.reduce((m, r) => {
    m[r.value] = r.label;
    return m;
  }, {} as {[k: number]: string});

  return val ? map[val] : '';
}

export function formatTimeRange (beginTime: number | string, endTime: number | string) {
  const begin = moment(beginTime);
  const end = moment(endTime);
  const isToday = moment().isSame(beginTime, 'date');
  return `${begin.format('YYYY年MM月DD日')}（${isToday ? '今天' : begin.format('周dd')}） ${begin.format('HH:mm')} - ${formatEndTime(end.format('HH:mm'))}`;
}

export function formatMeetingMember (members: MeetingMember[]) {
  if (!members) return '';
  return members.map(member =>
    member.remark ||
    member.user.displayName ||
    member.user.realName ||
    member.user.realname
  ).join('，');
}

export function parseHtml (str: string) {
  if (!str) return '';

  const res = str.replace(/<(\/p|\/li|br\/?)>/g, '\n').replace(/<.+?>/g, '');

  return res;
}

// 组装url参数 返回格式：?x1=v1&x2=v2
export const queryStringify = (obj: any) => {
  if (!obj) return '';
  const str = Object.keys(obj).reduce((t, k) => {
    if (!k) return t;
    t += `&${k}=${obj[k]}`;
    return t;
  }, '');
  return str ? `?${str.slice(1)}` : '';
};

/**
 * 00:00 -> 24:00
 */
export function formatEndTime(endTime: string) {
  return endTime === '00:00' ? '24:00' : endTime;
}

/**
 * 格式化预约时间
 */
export const formatBookTime = (startTime?: number | string, endTime?: number | string) => {
  /** 默认间隔为 30 分钟 */
  const minSpaceTimestamp = 15 * 60 * 1000;
  const spaceTimestamp = 30 * 60 * 1000;

  try {
    if (typeof startTime !== 'string' && typeof startTime !== 'number') { throw new Error('startTime 数据类型错误'); }
    if (typeof endTime !== 'string' && typeof endTime !== 'number') { throw new Error('endTime 数据类型错误'); }

    /** 数据序列化 */
    const startTimeObj = dayjs(Number(startTime));
    const endTimeObj = dayjs(Number(endTime));

    if (endTimeObj.isBefore(startTime)) { throw new Error('结束时间不能早于开始时间'); }
    if (endTimeObj.valueOf() - startTimeObj.valueOf() < minSpaceTimestamp) { throw new Error('小于最小可预约时长'); }
    if (endTimeObj.isSame(startTimeObj, 'day') === false) { throw new Error('预约的开始结束时间不在同一天'); }
    if (startTimeObj.isBefore(dayjs())) throw new Error('会议时间已过去');

    startTime = startTimeObj.valueOf();
    endTime = endTimeObj.valueOf();
  } catch (err) {
    console.log('formatBookTime error ===>', err);

    /** 超过 19 点，默认选中第二天 9:00 到 9:30 */
    if (dayjs().get('hours') >= 19) {
      startTime = dayjs().startOf('date').add(1, 'day').hour(9).valueOf();
    } else {
      startTime = dayjs().valueOf();
    }
    endTime = startTime + spaceTimestamp;
  }

  /** 匹配最近可预约时间 */
  startTime = Math.ceil(startTime / minSpaceTimestamp) * minSpaceTimestamp;
  endTime = Math.ceil(endTime / minSpaceTimestamp) * minSpaceTimestamp;

  // 后台要求，最晚只能约到 23:59:00
  endTime = Math.min(
    dayjs(endTime).endOf('date').second(0).millisecond(0).valueOf(),
    endTime
  );

  return {
    startTime,
    endTime
  };
};
